const pagerPrevIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
      <path fill="#979797" d="M16,20.5 C15.8091546,20.5 15.6183092,20.4364214 15.4729387,20.3099131 L11,16.4173479 L12.0541226,15.5 L16,18.9338913 L19.9458774,15.5 L21,16.4173479 L16.5270613,20.3099131 C16.3816908,20.4364214 16.1908454,20.5 16,20.5 Z" transform="rotate(90 16 5)"/>
    </svg>
`;

export default pagerPrevIcon;
